import React from 'react'
import { Link } from 'react-router-dom'

const formatDateParam = (date) => date.toISOString().slice(0, 10);

const getReportDateRange = (mode) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (mode === 'weekly') {
        const weekStart = new Date(today);
        weekStart.setDate(weekStart.getDate() - 7);

        return {
            fromDate: formatDateParam(weekStart),
            toDate: formatDateParam(today)
        };
    }

    return {
        fromDate: formatDateParam(today),
        toDate: formatDateParam(today)
    };
};

const buildReportLink = (pathname, filter, mode, extraParams = {}) => {
    const { fromDate, toDate } = getReportDateRange(mode);
    const params = new URLSearchParams({ filter, fromDate, toDate, ...extraParams });

    return {
        pathname,
        search: `?${params.toString()}`
    };
};

const DailyWeeklyReport = ({data , loading}) => {
    return (
        <>
            <div className="col-xl-6">
                <div className="d-lg-flex align-items-center justify-content-between">
                    <h5 className="mt-4 mb-3">Daily Report</h5>
                
                </div>
                <div className="card custom-card main-dashboard-banner overflow-hidden">
                    <div className="card-body p-4">
                        <div className="row justify-content-between">
                            <div className="col-sm-12">
                                
                                <div className="desk-package">
                                    <div className="d-flex align-items-center justify-content-start">
                                        <div className="packicon mr-lg-2">
                                            <span>
                                                <i className="far fa-lock" />
                                            </span>
                                        </div>
                                        <div className="packdet d-flex align-items-center justify-content-between">
                                            <Link to={buildReportLink('/user/all-member', 'dailyNewRegistration', 'daily')}>
                                            <span>New Registration</span>
                                            <h5 className="mb-0">{loading ? "Loading..." : data?.dailyNewRegistration}</h5>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="desk-package">
                                    <div className="d-flex align-items-center justify-content-start">
                                        <div className="packicon mr-lg-2">
                                            <span>
                                                <i className="far fa-users" />
                                            </span>
                                        </div>
                                        <div className="packdet d-flex align-items-center justify-content-between">
                                            <Link to={buildReportLink('/transaction-history', 'dailyNewPaidMembers', 'daily', { status: 'Paid' })}>
                                            <span>New Paid Members</span>
                                            <h5 className="mb-0">{loading ? "Loading..." : data?.dailyNewPaidMembers}</h5>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="desk-package">
                                    <div className="d-flex align-items-center justify-content-start">
                                        <div className="packicon mr-lg-2">
                                            <span>
                                                <i className="far fa-users" />
                                            </span>
                                        </div>
                                        <div className="packdet d-flex align-items-center justify-content-between">
                                                <Link to={buildReportLink('/transaction-history', 'dailyRevenue', 'daily', { status: 'Paid' })}>
                                            <span>Total Revenue</span>
                                            <h5 className="mb-0">{loading ? "Loading..." : data?.dailyTotalRevenue}</h5>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-lg-flex align-items-center justify-content-between">
                    <h5 className="mt-4 mb-3">Weekly Report</h5>
                    {/* <a href="view-lead.html" style="color: #dd2378; font-weight: 600; margin-top: 10px;">View All</a> */}
                </div>
                <div className="card custom-card main-dashboard-banner main-dashboard-banner2 overflow-hidden">
                    <div className="card-body p-4">
                        <div className="row justify-content-between">
                            <div className="col-sm-12">
                                {/* <h4 class="mb-3 fw-medium text-white">Daily Report</h4> */}
                                <div className="desk-package">
                                    <div className="d-flex align-items-center justify-content-start">
                                        <div className="packicon mr-lg-2">
                                            <span>
                                                <i className="far fa-lock" />
                                            </span>
                                        </div>
                                        <div className="packdet d-flex align-items-center justify-content-between">
                                                <Link to={buildReportLink('/user/all-member', 'weeklyNewRegistration', 'weekly')}>
                                            <span>Weekly Registration</span>
                                            <h5 className="mb-0">{loading ? "Loading..." : data?.weeklyNewRegistration}</h5>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="desk-package">
                                    <div className="d-flex align-items-center justify-content-start">
                                        <div className="packicon mr-lg-2">
                                            <span>
                                                <i className="far fa-users" />
                                            </span>
                                        </div>
                                        <div className="packdet d-flex align-items-center justify-content-between">
                                            <Link to={buildReportLink('/transaction-history', 'weeklyNewPaidMembers', 'weekly', { status: 'Paid' })}>
                                            <span>Weekly Paid Members</span>
                                            <h5 className="mb-0">{loading ? "Loading..." : data?.weeklyNewPaidMembers}</h5>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="desk-package">
                                    <div className="d-flex align-items-center justify-content-start">
                                        <div className="packicon mr-lg-2">
                                            <span>
                                                <i className="far fa-users" />
                                            </span>
                                        </div>
                                        <div className="packdet d-flex align-items-center justify-content-between">
                                            <Link to={buildReportLink('/transaction-history', 'weeklyRevenue', 'weekly', { status: 'Paid' })}>
                                            <span>Total Revenue</span>
                                            <h5 className="mb-0">{loading ? "Loading..." : data?.weelyTotalRevenue}</h5>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* end */}
            </div>
        </>
    )
}

export default DailyWeeklyReport